import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchIdentity } from '@office-start/identity-service';
import { format } from '@office-start/string-formatter-utility';
import { logError } from '@office-start/telemetry-service';
import { AppHostAuthenticationService } from './AppHostAuthenticationService';
import { AppId, getExpiry, getWamAccessToken, isWindowsAuthAvailable, KnownAuthorities, } from './WindowsTokens';
// Hubsdk will append authId and result to the uri when running the script.
// It will look like 'ms-getoffice:authcallback?appId=aAppId&authId=aAuthId&result=authResult'
var authRedirectUrlFormat = 'ms-getoffice:authcallback?appId={0}';
var getAuthRedirectUrl = function (mosAppId) {
    return new URL(format(authRedirectUrlFormat, mosAppId));
};
var getWamAccessTokenResponseFunction = function (user) {
    var wamAccessTokenResponseFunction = function (_tokenConsumer, _forceFetch, resourceUrl) { return __awaiter(void 0, void 0, void 0, function () {
        var result, response, account, isCommercial, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    if (!isWindowsAuthAvailable) {
                        logError({
                            eventName: 'Access_Token_Response',
                            errorType: 'GetOfficeToken_Error',
                            message: 'Windows auth not available',
                        });
                        return [2 /*return*/, Promise.reject('Windows auth not available')];
                    }
                    if (!resourceUrl) {
                        logError({
                            eventName: 'Access_Token_Response',
                            errorType: 'GetOfficeToken_Error',
                            message: 'Resource not provided',
                        });
                        return [2 /*return*/, Promise.reject('Resource not provided')];
                    }
                    return [4 /*yield*/, getWamAccessToken(resourceUrl, user)];
                case 1:
                    result = _b.sent();
                    response = (_a = result === null || result === void 0 ? void 0 : result.responseData) === null || _a === void 0 ? void 0 : _a[0];
                    account = response === null || response === void 0 ? void 0 : response.webAccount;
                    isCommercial = (account === null || account === void 0 ? void 0 : account.webAccountProvider.authority) === KnownAuthorities.AAD;
                    if (!(response === null || response === void 0 ? void 0 : response.token) ||
                        (result === null || result === void 0 ? void 0 : result.responseStatus) !==
                            Windows.Security.Authentication.Web.Core
                                .WebTokenRequestStatus.success) {
                        logError({
                            eventName: 'Access_Token_Response',
                            errorType: 'GetOfficeToken_Error',
                            message: 'unable to acquire token from WebTokenRequestResult',
                            debugInfo: ' wamAccessTokenResponseFunction',
                        });
                        return [2 /*return*/, Promise.reject('unable to acquire token from WebTokenRequestResult')];
                    }
                    return [2 /*return*/, {
                            success: true,
                            token: response.token,
                            format: isCommercial ? 'JWT' : 'RPSCompact',
                            source: 'WAM',
                            expiryMs: getExpiry(response === null || response === void 0 ? void 0 : response.properties, isCommercial),
                            error: result === null || result === void 0 ? void 0 : result.responseError,
                            clientId: AppId,
                        }];
                case 2:
                    error_1 = _b.sent();
                    logError({
                        eventName: 'Access_Token_Response',
                        errorType: 'GetOfficeToken_Error',
                        message: "wamAccessTokenResponseFunction failed: ".concat(error_1),
                        debugInfo: 'format: JWT, source: WAM',
                    });
                    return [2 /*return*/, {
                            success: false,
                            format: 'JWT',
                            source: 'WAM',
                            token: '',
                            error: error_1,
                        }];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return wamAccessTokenResponseFunction;
};
export var getAuthenticationService = function (appId) { return __awaiter(void 0, void 0, void 0, function () {
    var officeComponentContext, officeIdentity, authRedirectUrl, userProfile, accessTokenResponseFunction, appHostAuthenticationService;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
            case 1:
                officeComponentContext = _c.sent();
                return [4 /*yield*/, fetchIdentity()];
            case 2:
                officeIdentity = _c.sent();
                if (!officeComponentContext || !officeIdentity) {
                    return [2 /*return*/, undefined];
                }
                authRedirectUrl = getAuthRedirectUrl(appId);
                userProfile = {
                    profile: {
                        upn: (_a = officeIdentity.userPrincipalName) !== null && _a !== void 0 ? _a : '',
                        tid: officeIdentity.tenantId,
                        oid: officeIdentity.objectId,
                        loginHint: (_b = officeIdentity === null || officeIdentity === void 0 ? void 0 : officeIdentity.loginHint) !== null && _b !== void 0 ? _b : '',
                    },
                };
                accessTokenResponseFunction = isWindowsAuthAvailable
                    ? getWamAccessTokenResponseFunction(userProfile)
                    : officeComponentContext.getAccessToken;
                appHostAuthenticationService = new AppHostAuthenticationService(accessTokenResponseFunction, userProfile, authRedirectUrl);
                return [2 /*return*/, appHostAuthenticationService];
        }
    });
}); };
//# sourceMappingURL=getAppHostAuthenticationService.js.map